// src/features/dashboard/admin/RoleBadge.jsx
import React from 'react';

export const RoleBadge = ({ role }) => {
  const styles =
    role === "admin"
      ? "bg-purple-100 text-purple-800"
      : role === "teacher"
        ? "bg-indigo-100 text-indigo-800"
        : "bg-blue-100 text-blue-800";
  return (
    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${styles}`}>
      {role}
    </span>
  );
};